<div class="main-content">

  <div class="card" translate>
    <div class="card-body" translate>
      STATUS
    </div>
  </div>
</div>